import { render } from "./exchangeDialog.vue?vue&type=template&id=15bdda5a&scoped=true"
import script from "./exchangeDialog.vue?vue&type=script&lang=js"
export * from "./exchangeDialog.vue?vue&type=script&lang=js"

import "./exchangeDialog.vue?vue&type=style&index=0&id=15bdda5a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bdda5a"]])

export default __exports__